import { render, staticRenderFns } from "./notificationC.vue?vue&type=template&id=1af50920&"
import script from "./notificationC.vue?vue&type=script&lang=js&"
export * from "./notificationC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports